import React, { useEffect, useState } from 'react'
import apiClient from '../../services/apiClient'
import { CBadge, CCard, CCardBody, CImage, CCol, CRow } from '@coreui/react'
import aoiPic1 from 'src/assets/brand/ic_launcher.png'
import BadgeComponent from './BadgeComponent'
import { buildApiUrl } from '../../utils/getConfiguration'
import { useTranslation } from 'react-i18next'

const WidgetSum = () => {
  const [toprecommendations, setTopRecommendations] = useState([])
  const { t } = useTranslation()

  const fetchTopRecommendationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(
        buildApiUrl('remindersTopAllInMonth', {
          account_ID,
          grp_ID: 4,
        }),
      )

      setTopRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchTopRecommendationsData()
  }, [])

  const [accountdamages, setAccountdamage] = useState([])

  const fetchAccountdamageData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(
        buildApiUrl('accountDamageAll', {
          account_ID,
        }),
      )
      setAccountdamage(response.data)
    } catch (error) {
      console.error('Error fetching score', error)
    }
  }

  useEffect(() => {
    fetchAccountdamageData()
  }, [])

  const [activeRecommendations, setActiveRecommendations] = useState([])

  const fetchActiveRecommendationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(
        buildApiUrl('accountRemindersAllActiveInMonth', {
          account_ID,
        }),
      )
      setActiveRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching active recommendations', error)
    }
  }

  useEffect(() => {
    fetchActiveRecommendationsData()
  }, [])

  const [progressRecommendations, setProgressRecommendations] = useState([])

  const fetchProgressRecommendationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(
        buildApiUrl('accountRemindersProgressAll', {
          account_ID,
        }),
      )
      setProgressRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching active recommendations', error)
    }
  }

  useEffect(() => {
    fetchProgressRecommendationsData()
  }, [])

  return (
    <div className="alert alert-light" role="alert">
      <CCard key={1} className="col-md-12">
        <CCardBody>
          <CRow>
            <CCol>
              <CImage
                rounded
                orientation="top"
                src={aoiPic1}
                width={25}
                height={25}
                //onClick={() => {
                //console.log('Task Detail ' + recommendation.reminder_ID)
                //localStorage.setItem('taskid', recommendation.reminder_ID)
                //localStorage.setItem('grp_ID', '4')
                //navigate('/risks')
                //}}
              />
            </CCol>
            <CCol>
              {toprecommendations.length > 0 &&
                toprecommendations.map((toprecommendation, index) => (
                  <BadgeComponent
                    key={`${toprecommendation.reminder_ID ?? toprecommendation.Prio ?? index}`}
                    priority={toprecommendation.Prio}
                  />
                ))}
            </CCol>
            <CCol xs={12}>
              {accountdamages.map((accountdamage, index) => (
                <small key={`damage-${accountdamage.account_ID ?? index}`}>
                  {t('widgets.sum.labels.risk')}:{' '}
                  {(Number(accountdamage.SUMPOINTS) || 0).toLocaleString('cs-CZ', {
                    maximumFractionDigits: 2,
                  })}
                  $
                </small>
              ))}
            </CCol>
            <CCol xs={6}>{t('widgets.sum.labels.toFulfill')}:</CCol>
            <CCol xs={6}>
              <CBadge color="info" className="ms-2">
                {activeRecommendations.length}
              </CBadge>
            </CCol>
            <CCol xs={6}>{t('widgets.sum.labels.progress')}:</CCol>
            <CCol xs={6}>
              <CBadge color="info" className="ms-2">
                {progressRecommendations.map((progressrecommendation, index) => (
                  <div
                    key={`progress-${progressrecommendation.reminder_ID ?? index}`}
                    className="mb-1"
                  >
                    {progressrecommendation.Progress}%
                  </div>
                ))}
              </CBadge>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </div>
  )
}

export default WidgetSum
